var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.description)?_c('div',{staticClass:"content-block-phrase"},[_c('div',{staticClass:"content-block-phrase__text",domProps:{"innerHTML":_vm._s(_vm.data.description)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }